import { render, staticRenderFns } from "./InvitationHeader.vue?vue&type=template&id=f72adb5e&scoped=true"
import script from "./InvitationHeader.vue?vue&type=script&lang=js"
export * from "./InvitationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72adb5e",
  null
  
)

export default component.exports